import { createSlice } from '@reduxjs/toolkit';

const initialState = localStorage.getItem('planificacionDisplayAsignaturasRuta') !== 'false';

const planificacionDisplayAsignaturasRutaSlice = createSlice({
	name: 'planificacionDisplayAsignaturasRuta',
	initialState,
	reducers: {
		changeDisplayAsignatura: (state, action) => {
			const hide = action.payload === false;
			if (hide) {
				localStorage.setItem('planificacionDisplayAsignaturasRuta', 'false');
			} else {
				localStorage.removeItem('planificacionDisplayAsignaturasRuta');
			}
			return action.payload;
		}
	}
});

export const { changeDisplayAsignatura } = planificacionDisplayAsignaturasRutaSlice.actions;
export default planificacionDisplayAsignaturasRutaSlice.reducer;
